<template>
	<v-form ref="form" v-model="formIsValid" lazy-validation>
		<modal
			:exibir="exibir"
			:titulo="tituloModal"
			:custom-actions="false"
			:acao-cancelar="fecharModal"
			:acao-confirmar="confirmar"
			nome-botao-confirmar="Salvar"
			:is-confirmar-visivel="isConfirmarVisivel"
			:is-confirmar-desabilitado="isConfirmarDesabilitado"
			:tamanho="modalOptions"
			@close="fecharModal"
		>
			<template #body>
				<div class="my-1" :class="{ ajustar_modal_aba_historico: !$vuetify.breakpoint.mobile }">
					<painel-com-tabs-sem-rotas
						:tabs="tabs"
						@tab-atual="botaoSalvarNaoDeveAparecerNaAbaHistoricoAndListagemDeOrgaos"
					>
						<template #transferencia>
							<transferencia
								:is-listagem="isListagem"
								@recarregar-listagem="recarregarListagem"
								@mudar-estado-botao-salvar="botaoSalvarNaoDeveAparecerNaAbaHistoricoAndListagemDeOrgaos"
							></transferencia>
						</template>
						<template #historico>
							<historico-transferencia
								v-if="isHistorico || !temPermissaoEdicao"
							></historico-transferencia>
						</template>
						<template #acoes-tabs>
							<botao-gerar-pdf-historico
								:tipo-historico="tipoHistorico.HISTORICO_GERENCIA_SALDO_ITEM_ATA"
								:id-entidade="itemSelecionado.id"
								v-if="isHistorico || !temPermissaoEdicao"
							></botao-gerar-pdf-historico>
						</template>
					</painel-com-tabs-sem-rotas>
				</div>
			</template>
		</modal>
	</v-form>
</template>

<script>
import { TabSemRotaUtils } from '@/core/utils'
import { actionTypes, getterTypes, mutationTypes } from '@/core/constants'
import { mapState } from 'vuex'
import validacaoAta from '@/views/mixins/validacaoAta'
import Transferencia from '@/views/pages/ata/acessar/gestao-da-ata/itens/listagem/gerenciar-estoque/transferencia/Transferencia.vue'
import PainelComTabsSemRotas from '@/views/components/PainelComTabsSemRotas.vue'
import HistoricoTransferencia from '@/views/pages/ata/acessar/gestao-da-ata/itens/listagem/gerenciar-estoque/historico/Historico.vue'
import tipoHistorico from '@/core/constants/tipo-historico'
import BotaoGerarPdfHistorico from '@/views/components/botoes/gerar-pdf-historico/BotaoGerarPdfHistorico.vue'

export default {
	name: 'modal-gerenciar-estoque',
	components: { BotaoGerarPdfHistorico, HistoricoTransferencia, PainelComTabsSemRotas, Transferencia },
	mixins: [validacaoAta],
	props: {
		exibir: {
			type: Boolean,
		},
	},
	data() {
		return {
			tabs: [
				new TabSemRotaUtils(1, 'Remanejamento', 'transferencia', () => this.temPermissaoEdicao),
				new TabSemRotaUtils(2, 'Histórico', 'historico', this.existeHistorico),
			],
			tituloModal: 'Remanejar Saldo',
			modalOptions: {
				largura: '900',
				altura: '500',
			},
			isConfirmarVisivel: false,
			formIsValid: true,
			isListagem: true,
			isHistorico: false,
		}
	},

	computed: {
		tipoHistorico() {
			return tipoHistorico
		},
		...mapState({
			itemSelecionado: (state) => state.itemAta.itemSelecionado,
			transferirSaldo: (state) => state.itemAta.transferencia.transferir.transferirSaldo,
		}),
		isConfirmarDesabilitado() {
			return !this.formIsValid
		},
	},
	beforeDestroy() {
		this.resetarAlteracoesTransferencia()
	},
	methods: {
		botaoSalvarNaoDeveAparecerNaAbaHistoricoAndListagemDeOrgaos(tabValue, idOrgaoSelecionado, tipoAlteracaoSaldo) {
			const naoEhHistorico = tabValue !== 2

			this.isHistorico = this.isAbaHistorico(tabValue)

			this.isConfirmarVisivel = !!(
				this.temPermissaoEdicao &&
				(idOrgaoSelecionado || tipoAlteracaoSaldo) &&
				naoEhHistorico
			)
		},
		isAbaHistorico(tabValue) {
			return tabValue === 1
		},
		fecharModal() {
			this.isListagem = true
			this.resetarAlteracoesTransferencia()
			this.$emit('carregar-listagem-item')
			this.$emit('fechar-modal')
		},

		async confirmar() {
			if (this.$refs.form.validate()) {
				await this.$store.dispatch(actionTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.TRANSFERIR_SALDO)
				this.mostrarNotificacaoSucessoDefault()
				this.recarregarListagem()
				this.botaoSalvarNaoDeveAparecerNaAbaHistoricoAndListagemDeOrgaos(1)
				this.$store.commit(mutationTypes.ITEM_ATA.SET_HISTORICO_GERENCIAR_SALDO, true)
			}
		},
		recarregarListagem() {
			this.isListagem = !this.isListagem

			if (this.isListagem) {
				this.resetarAlteracoesTransferencia()
			}
		},
		resetarAlteracoesTransferencia() {
			this.$store.commit(mutationTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.RESET_ALTERACOES_TRANSFERENCIA)
		},
		existeHistorico() {
			return this.$store.getters[getterTypes.ITEM_ATA.EXISTE_HISTORICO_GERENCIAR_SALDO]
		},
	},
}
</script>

<style lang="stylus" scoped>

.ajustar_modal_aba_historico {
	height: 67vh;
}
</style>
